import React, { useEffect } from "react";
import blogData from "../../Json/BlogData.json";
import { myCustomTheme } from "../../Theme";
import "../../Style/BlogSection.css";

import {
  FiCalendar,
  FiMessageSquare,
} from "react-icons/fi";

// IMPORT YOUR IMAGES
import img1 from "../../Assets/Our-Section.jpg";
import img2 from "../../Assets/Blog-1.jpg";
import img3 from "../../Assets/Blog-2.jpg";

const BlogSection = () => {

  // ✅ IMAGE MAPPING SYSTEM
  const images = {
    blog1: img1,
    blog2: img2,
    blog3: img3,
  };

  // ✅ SECTION OPEN ANIMATION
  useEffect(() => {

    const section = document.querySelector(".blog-section");

    const observer = new IntersectionObserver(
      (entries) => {

        entries.forEach((entry) => {

          if (entry.isIntersecting) {
            entry.target.classList.add("show");
          }

        });

      },
      { threshold: 0.2 }
    );

    if (section) {
      observer.observe(section);
    }

    return () => {
      if (section) {
        observer.unobserve(section);
      }
    };

  }, []);

  return (
    <section
      className="blog-section"
      style={{
        fontFamily: myCustomTheme.typography.text_font,
      }}
    >

      {/* Background Decorative Elements */}
      <div className="gradient-circle circle-1"></div>

      <div className="grid-overlay"></div>

      <div className="container-fluid">

        {/* CUSTOM CONTAINER */}
        <div className="blog-container">

          {/* HEADER SECTION */}
          <div className="blog-header">

            <span className="blog-tag">
              BLOG & NEWS
            </span>

            <h1
              style={{
                fontFamily:
                  myCustomTheme.typography.heading_font,
              }}
            >
              3D Printing in the News
            </h1>

            <p>
              Stay updated with the latest trends,
              innovations, and stories shaping the
              future of 3D printing and manufacturing.
            </p>

          </div>

          {/* BLOG GRID */}
          <div className="blog-grid">

            {blogData.map((blog, index) => (
              <div
                className="blog-card"
                key={blog.id}
                style={{
                  animationDelay: `${index * 0.2}s`,
                }}
              >

                {/* IMAGE */}
                <div className="blog-image">

                  <img
                    src={images[blog.imageKey]}
                    alt={blog.title}
                  />

                </div>

                {/* CONTENT */}
                <div className="blog-content">

                  {/* META */}
                  <div className="blog-meta">

                    <span>
                      <FiCalendar className="meta-icon" />
                      {blog.date}
                    </span>

                    <span>
                      <FiMessageSquare className="meta-icon" />
                      {blog.comments}
                    </span>

                  </div>

                  {/* TITLE */}
                  <h2
                    style={{
                      fontFamily:
                        myCustomTheme.typography.heading_font,
                    }}
                  >
                    {blog.title}
                  </h2>

                  {/* DESCRIPTION */}
                  <p>
                    {blog.description}
                  </p>

                </div>

              </div>
            ))}

          </div>

        </div>
      </div>
    </section>
  );
};

export default BlogSection;